import { createTheme } from '@mui/material/styles';
const theme = createTheme();
const shadows = [...theme.shadows];
shadows[1] = '0px 0px 1px 0px rgba(32, 35, 39, 0.16), 0px 4px 8px 0px rgba(32, 35, 39, 0.04), 0px 8px 48px 0px rgba(32, 35, 39, 0.02)';
export default shadows;